/** Helper to make document.querySelector calls shorter and easier
 * e.g. qs`.input`              =>  document.querySelector('.input')
 *      qs(elem)`.input`        =>  elem.querySelector('.input')
 *      qs`.child-${index}`     =>  document.querySelector(`.child-${index}`)
 */
export const qs = _query(false);

/** Helper to make document.querySelectorAll calls with less boilerplate
  * Same behaviour as qs but for querySelectorAll
 */
export const qsa = _query(true);

function _query(all = false, rootElement = document) {
  return (selectors, ...params) => {
    if (selectors instanceof HTMLElement) {
      return _query(all, selectors);
    }

    let output = '';

    for (let i = 0; i < selectors.length; ++i) {
      output += selectors[i];

      if (params.length > i) {
        output += params[i];
      }
    }

    return all ? rootElement.querySelectorAll(output) : rootElement.querySelector(output);
  };
}
